<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name" />

    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="">
        <el-form-item label="用户姓名">
          <el-input v-model="searchData.idName" size="small" placeholder="请输入姓名"></el-input>
        </el-form-item>

        <el-form-item label="手机号">
          <el-input v-model="searchData.mobile" size="small" placeholder="请输入手机号"></el-input>
        </el-form-item>

        <el-form-item label="身份证号">
          <el-input v-model="searchData.idCard" size="small" placeholder="请输入身份证号"></el-input>
        </el-form-item>

        <el-form-item label=" " label-width="50px">
          <el-button type="primary" size="small" icon="el-icon-search" @click="getList">搜索</el-button>
          <el-button type="info" size="small" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <tp-table
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
    />

    <div style="height:50px"></div>
  </div>
</template>

<script>
import { authBtnMixin } from '@/mixins/authBtnMixin';
import { getListAPI } from './api';

const columns = [
  {
    label: 'UID',
    prop: 'id',
    minWidth: '80',
    customRender(h, row) {
      return <p>{ row['id'] }</p>
    }
  },
  {
    label: '用户姓名',
    prop: 'idName',
    minWidth: '120',
    customRender(h, row) {
      return <p>{ row['idName'] }</p>
    }
  },
  {
    label: '身份证号',
    prop: 'idCard',
    minWidth: '180',
    customRender(h, row) {
      return <p>{ row['idCard'] }</p>
    }
  },
  {
    label: '首次注册时间',
    prop: 'registerTime',
    minWidth: '180',
    customRender(h, row) {
      return <p>{ row['registerTime'] }</p>
    }
  },
  {
    label: '全域账号数/平台数',
    prop: 'qyStatNum',
    minWidth: '150',
    customRender(h, row) {
      return <p>{ row['qyAccountNum'] }/{ row['qyAppNum'] }</p>
    }
  },
  {
    label: '全域可信名单库',
    prop: 'rosterList',
    minWidth: '100',
    customRender(h, row) {
      return (
        <el-tag v-show={ !!row['isBlacklist'] } class="blacklist" size="small">黑名单</el-tag>
      )
    }
  },
  {
    label: '操作',
    width: '180',
    fixed: 'right',
    customRender(h, row) {
      return (
        <div>
          <el-link
            disabled={ !this.isShowBtn(this.AUTH_BTN.member_list_detail) }
            underline={ false }
            type="primary"
            style="margin-right: 5px;"
            onClick={() => {
              let link = this.$router.resolve({
                name: `MemberDetail`,
                params: { id: row["id"] },
              });
              window.open(link.href, "_blank");
            }}
          >
            详情
          </el-link>
        </div>
      )
    }
  }
]

export default {
  name: 'MemberList',
  mixins: [authBtnMixin],
  data() {
    return {
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        idName: '',
        idCard: '',
        mobile: '',
      },
    }
  },

  provide() {
    return {
      context: this
    }
  },

  watch: {
    currentPage() {
      this.getList();
    },

    pageSize() {
      this.getList();
    },
  },

  mounted() {
    this.getList();
  },

  methods: {
    async getList() {
      let params = { page: this.currentPage, riskLevel: 2, pageSize: this.pageSize };
      Object.assign(params, this.searchData);
      const res = await getListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    },

    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getList();
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;

  .header-search {
    .el-form {
      .el-form-item {
        margin-right: 35px;

        .el-input {
          width: 250px;
        }

        .el-date-editor {
          .el-range-separator {
            padding: 0;
          }

          .el-range-input {
            width: 35%;
          }
        }
      }
    }
  }

  .el-divider--horizontal {
    margin: 0 0 20px;
  }

  .blacklist {
    color: #ffffff;
    background-color: #000000;
    font-weight: bold;
  }
}
</style>
